import moment from "moment/moment";

export default  {
    methods: {
        processEquipment(payload,equipmentName){
            if(payload.filters.equipment_name) {
                if (payload.pipeline && payload.pipeline.length > 0) {
                    for (let stage of payload.pipeline) {
                        if (stage.type === "filter") {
                            stage.filter_by = stage.filter_by.replace(payload.filters.equipment_name + " - ", equipmentName + " - ")
                        } else if (stage.formula && stage.formula !== "") {
                            stage.formula = stage.formula.replaceAll(payload.filters.equipment_name + " - ", equipmentName + " - ")
                            if (stage.name && stage.name !== "") {
                                stage.name = stage.name.replaceAll(payload.filters.equipment_name + " - ", equipmentName + " - ")
                            }
                        } else if (stage.type==="select_series"&&stage.series) {
                            stage.series=stage.series.map(x=>x.replaceAll(payload.filters.equipment_name + " - ", equipmentName + " - "))
                        } else if (stage.type === "insert_series") {
                            stage.name = stage.name.replace(payload.filters.equipment_name + " - ", equipmentName + " - ")
                            if (stage.filters && stage.filters.equipment_name === payload.filters.equipment_name) {
                                stage.filters.equipment_name = equipmentName
                            }
                        }
                    }
                }
                payload.filters.equipment_name = equipmentName
            }
        },
        processDateRange(payload, dateRange) {
            // Define helper function at the top level to be accessible everywhere
            const include00Timestamp = payload.include00Timestamp !== undefined ? payload.include00Timestamp : false;
            const cleanTimeStamp = (date) => {
                if (!date) return null; // Guard against null/undefined dates
                if (include00Timestamp) {
                    return date.length < 12 ? moment(date).add(1, 'day').format('YYYY-MM-DD') + ' 00:00:00' : date;
                }
                return date.length < 12 ? date + " 23:59:59" : date;
            };

            // Timeline parameter takes highest priority — overrides all other range options
            if (payload.useTimelineParameter && payload.timelineParameterName) {
                const timelines = payload.parameters && payload.parameters._timelines;
                const tlRange = timelines && timelines[payload.timelineParameterName];
                if (tlRange && tlRange.start && tlRange.end) {
                    payload.date_range = [tlRange.start, cleanTimeStamp(tlRange.end)];
                    return;
                }
                // Fall through to normal logic if the named timeline has no value yet
            }

            if (payload.useCustomRange) {
                if (payload.useCustomRelativeRange) {
                    let relRange = payload.customRelativeRange && payload.customRelativeRange !== "" ? payload.customRelativeRange : "30 days";
                    let newRange = null;
                    let maxDate = this.$store.state.pointsListStore.pointsList.data_max_date;
                    let baseDate = moment();

                    if (maxDate) {
                        baseDate = moment(maxDate);
                    }
                    let startDate = baseDate.clone().subtract(30, "days");
                    if (relRange === "current week") {
                        startDate = baseDate.clone().startOf("week");
                    } else if (relRange === "current month") {
                        startDate = baseDate.clone().startOf("month");
                    } else if (relRange === "today" || relRange === "today full") {
                        startDate = baseDate.clone().startOf("day");
                    } else if (relRange === "current year") {
                        startDate = baseDate.clone().startOf("year");
                    } else if (relRange === "last week") {
                        baseDate = baseDate.subtract(1, "week").endOf("week");
                        startDate = baseDate.clone().startOf("week");
                    } else if (relRange === "last month") {
                        baseDate = baseDate.subtract(1, "month").endOf("month");
                        startDate = baseDate.clone().startOf("month");
                    } else if (relRange === "yesterday") {
                        baseDate = baseDate.subtract(1, "day").endOf("day");
                        startDate = baseDate.clone().startOf("day");
                    } else if (relRange === "last year") {
                        baseDate = baseDate.subtract(1, "year").endOf("year");
                        startDate = baseDate.clone().startOf("year");
                    } else if (relRange === "today and tomorrow") {
                        startDate = baseDate.clone().startOf("day");
                        baseDate = baseDate.add(1, "day").endOf("day");
                    }

                    if (relRange === "yesterday" || relRange === "today" || relRange === "today and tomorrow") {
                        newRange = { start: startDate.format('YYYY-MM-DD HH:mm:ss'), end: baseDate.format('YYYY-MM-DD HH:mm:ss') };
                    } else {
                        newRange = { start: startDate.format('YYYY-MM-DD'), end: baseDate.format('YYYY-MM-DD') };
                    }

                    if (payload.customRelativeRangeStartOnly && dateRange && dateRange.end) {
                        payload.date_range = [newRange.start, cleanTimeStamp(dateRange.end)];
                    } else {
                        payload.date_range = [newRange.start, cleanTimeStamp(newRange.end)];
                    }
                } else if (payload.customRange) {
                    if (payload.customRangeStartOnly && dateRange && dateRange.end) {
                        payload.date_range = [payload.customRange.start, cleanTimeStamp(dateRange.end)];
                    } else {
                        payload.date_range = [payload.customRange.start, cleanTimeStamp(payload.customRange.end)];
                    }
                }
            } else if (dateRange) {
                if (payload.offsetRange && payload.offsetType) {
                    if (payload.offsetRangeStartOnly) {
                        let startDate;
                        if ((payload.offsetType === "year" || payload.offsetType === "years") && payload.offsetPreciseYear) {
                            startDate = moment(dateRange.start).set('year', payload.offsetPreciseYear).format('YYYY-MM-DD');
                        } else {
                            startDate = moment(dateRange.start).subtract(payload.offsetAmount, payload.offsetType).format('YYYY-MM-DD');
                        }
                        payload.date_range = [startDate, cleanTimeStamp(dateRange.end)];
                    } else {
                        let startDate;
                        let endDate;
                        if ((payload.offsetType === "year" || payload.offsetType === "years") && payload.offsetPreciseYear) {
                            let yearsThatGotOffset = moment(dateRange.start).diff(moment(dateRange.start).set('year', payload.offsetPreciseYear), 'years');
                            startDate = moment(dateRange.start).set('year', payload.offsetPreciseYear).format('YYYY-MM-DD');
                            endDate = moment(dateRange.end).subtract(yearsThatGotOffset, 'years').format('YYYY-MM-DD');
                        } else {
                            startDate = moment(dateRange.start).subtract(payload.offsetAmount, payload.offsetType).format('YYYY-MM-DD');
                            endDate = moment(dateRange.end).subtract(payload.offsetAmount, payload.offsetType).format('YYYY-MM-DD');
                        }
                        payload.date_range = [startDate, cleanTimeStamp(endDate)];
                    }
                } else {
                    payload.date_range = [dateRange.start, cleanTimeStamp(dateRange.end)];
                }
            }
        },
        findMissingSensors(payloadArray){
            let missingSensors = []
            let checkEquipHasSensor= (equipmentName,sensorName)=>{
                if (!this.$store.state.pointsListStore.pointsList.sensors[equipmentName]||this.$store.state.pointsListStore.pointsList.sensors[equipmentName].indexOf(sensorName)===-1){
                    let newKey= equipmentName+" - "+sensorName
                    if (missingSensors.indexOf(newKey)===-1){
                        missingSensors.push(newKey)
                    }
                }
            }
            for (let payload of payloadArray){
                if (payload.filters.sensor_name){
                    if (payload.filters.equipment_name){
                        checkEquipHasSensor(payload.filters.equipment_name,payload.filters.sensor_name)
                    } else if (payload.filters.floor||payload.filters.equipment_type||(payload.filters.equipment_tags&&payload.filters.equipment_tags.length>0)) {
                        let matchingEquips=Object.values(this.$store.state.pointsListStore.pointsList.equipment_details)
                        if (payload.filters.floor){
                            matchingEquips=matchingEquips.filter(x=>x.floor===payload.filters.floor)
                        }
                        if (payload.filters.equipment_type){
                            matchingEquips=matchingEquips.filter(x=>x.equipment_type===payload.filters.equipment_type)
                        }
                        if (payload.filters.equipment_tags&&payload.filters.equipment_tags.length>0){
                            matchingEquips=matchingEquips.filter(x=>x.tags&&x.tags.length>0&&payload.equipment_tags.every(y=>x.tags.indexOf(y)!==-1))
                        }
                        for (let equip of matchingEquips){
                            checkEquipHasSensor(equip.equipment_name,payload.filters.sensor_name)
                        }
                    }
                }
                if (payload.pipeline && payload.pipeline.length > 0) {
                    for (let stage of payload.pipeline) {
                        if (stage.type === "insert_series") {
                            checkEquipHasSensor(stage.name.split(" - ")[0],stage.name.split(" - ")[1])
                        } else if (stage.type === "insert_series_by_ref"&&payload.filters.equipment_name&&this.$store.state.pointsListStore.pointsList.equipment_relationships){
                            let ref_type_array = stage.ref_type
                            if (!Array.isArray(ref_type_array)){
                                ref_type_array=[ref_type_array]
                            }
                            let equip_id=this.$store.state.pointsListStore.pointsList.equipment_details[payload.filters.equipment_name].equipment_id
                            let found_ids=this.$store.state.pointsListStore.pointsList.equipment_relationships.filter(x=>x.equip1===equip_id&&ref_type_array.includes(x.type)).map(x=>x.equip2)
                            if(stage.level&&stage.level>1){
                                for(let i=1;i<stage.level;i++){
                                    let new_ids=[]
                                    for (let id of found_ids){
                                        new_ids=new_ids.concat(this.$store.state.pointsListStore.pointsList.equipment_relationships.filter(x=>x.equip1===id&&ref_type_array.includes(x.type)).map(x=>x.equip2))
                                    }
                                    found_ids=new_ids
                                }
                            }
                            let found_equips=Object.values(this.$store.state.pointsListStore.pointsList.equipment_details).filter(x=>found_ids.indexOf(x.equipment_id)!==-1)
                            if (stage.equipment_type&&stage.equipment_type!==""){
                                found_equips=found_equips.filter(x=>x.equipment_type===stage.equipment_type)
                            }
                            for (let equip of found_equips){
                                checkEquipHasSensor(equip.equipment_name,stage.sensor_name)
                            }
                        }
                    }
                }
            }
            return missingSensors
        }
    }
};